import { splitPath } from "@/store/helpers";

export const stored = (state, getters) => getters.is_watching;

export const access = state =>
  path => {
    const parts = splitPath(path);
    let obj = state;
    for (const part of parts) obj = obj[part];
    return obj;
  };

export const ref = state => state.ref;

export const id = state => state.ref.id;

export const is_watching = state => state.document_listener ? true : false;

export const document_listener = state => state.document_listener;